import type { PricingTableColumn } from '../../types';
import { EPricingTableColumn } from '../../types/enums';

export const getToggleableColumns = (columns: PricingTableColumn[]): PricingTableColumn[] =>
  columns?.filter(
    column =>
      ![
        EPricingTableColumn.Name,
        EPricingTableColumn.Description,
        EPricingTableColumn.Sku,
        EPricingTableColumn.NetPrice,
      ].includes(column.name as EPricingTableColumn)
  );
